// extracted by mini-css-extract-plugin
export default {"root":"AboutMerchant_root__wfuF2","text":"AboutMerchant_text__I2Ofg"};